<template>
  <v-card
    flat
    class="vetalfa-card-grey-border pa-0 timeline-card"
    style="border-left: 4px solid #ff9800; overflow: hidden"
  >
    <v-row class="ma-0 pa-0" align="center" no-gutters>
      <v-col cols="auto" class="pa-3 d-flex align-center vetalfa-pointer" @click="open">
        <v-avatar size="36" color="orange" class="white--text">
          <v-icon small color="white">{{ mdiNeedle }}</v-icon>
        </v-avatar>
      </v-col>
      <v-col class="pa-3 pl-0 vetalfa-pointer" @click="open">
        <p class="ma-0 subtitle-2 font-weight-bold">
          {{ vaccination.vaccine || _getLabel("VACCINATION") }}
        </p>
        <p class="ma-0 caption grey--text text--darken-1">
          {{ formattedDate }}
        </p>
        <p v-if="manufacturerBatch" class="ma-0 caption mt-1" style="line-height: 1.3">
          {{ manufacturerBatch }}
        </p>
        <div class="mt-1">
          <v-chip
            x-small
            :color="isFinished ? 'success' : 'grey lighten-2'"
            :text-color="isFinished ? 'white' : 'grey darken-2'"
          >
            {{ isFinished ? _getLabel("FINALIZED") : _getLabel("DRAFT") }}
          </v-chip>
          <v-chip
            v-if="hasAddenda"
            x-small
            class="ml-1"
            color="blue lighten-4"
            text-color="blue darken-2"
          >
            {{ _getLabel("WITH_ADDENDUM") }}
          </v-chip>
          <v-chip
            v-if="vaccination.dose"
            x-small
            class="ml-1"
            color="grey lighten-2"
            text-color="grey darken-2"
          >
            {{ _getLabel("DOSE_NUMBER") }}: {{ vaccination.dose }}
          </v-chip>
          <v-chip
            v-if="vaccination.nextDoseDate"
            x-small
            class="ml-1"
            color="orange lighten-4"
            text-color="orange darken-3"
          >
            {{ _getLabel("NEXT_DOSE_DATE") }}: {{ formattedNextDoseDate }}
          </v-chip>
        </div>
        <p v-if="isFinished" class="ma-0 caption grey--text text--darken-1 mt-1">
          {{ _getLabel("FINALIZED_BY") }}: {{ signatureText }}
        </p>
      </v-col>
      <v-col cols="auto" class="pr-2 vetalfa-pointer" @click="open">
        <v-icon x-small color="grey">{{ mdiChevronRight }}</v-icon>
      </v-col>
    </v-row>

    <template v-if="!isFinished">
      <v-divider></v-divider>
      <v-row no-gutters class="px-2 py-1" align="center">
        <v-btn
          x-small
          text
          color="primary"
          class="text-none"
          @click.stop="$emit('finalize', vaccination)"
        >
          <v-icon x-small left>{{ mdiLockOutline }}</v-icon>
          {{ _getLabel("FINALIZE") }}
        </v-btn>
        <v-btn
          x-small
          text
          color="error"
          class="text-none"
          @click.stop="$emit('remove', vaccination)"
        >
          <v-icon x-small left>{{ mdiTrashCanOutline }}</v-icon>
          {{ _getLabel("DELETE_RECORD") }}
        </v-btn>
      </v-row>
    </template>
  </v-card>
</template>

<script>
import {
  mdiChevronRight,
  mdiNeedle,
  mdiLockOutline,
  mdiTrashCanOutline,
} from "@mdi/js";

export default {
  name: "VaccinationCard",
  props: {
    vaccination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiChevronRight,
      mdiNeedle,
      mdiLockOutline,
      mdiTrashCanOutline,
    };
  },
  computed: {
    formattedDate() {
      if (!this.vaccination.applicationDate && !this.vaccination.lastUpdate)
        return "-";
      return this._getDateFromTimestamp(
        this.vaccination.applicationDate || this.vaccination.lastUpdate
      );
    },
    formattedNextDoseDate() {
      if (!this.vaccination.nextDoseDate) return "-";
      return this._getDateFromTimestamp(this.vaccination.nextDoseDate);
    },
    manufacturerBatch() {
      const parts = [];
      if (this.vaccination.manufacturer)
        parts.push(this.vaccination.manufacturer);
      if (this.vaccination.batch) parts.push(this.vaccination.batch);
      return parts.join(" - ");
    },
    /**
     * O estado vem do servidor (`finalizedAt`), nunca de um status local.
     */
    isFinished() {
      return !!this.vaccination.finalizedAt;
    },
    hasAddenda() {
      return ((this.vaccination.addenda || []).length || 0) > 0;
    },
    signatureText() {
      const author = this.vaccination.finalizedBy || {};
      const name = [author.displayNamePrefix, author.displayName]
        .filter((part) => !!part)
        .join(" ");
      const crmv =
        author.crmvNumber || author.crmvState
          ? `CRMV ${author.crmvNumber || ""}${
              author.crmvState ? "-" + author.crmvState : ""
            }`.trim()
          : "";
      const date = this.vaccination.finalizedAt
        ? new Date(this.vaccination.finalizedAt).toLocaleString("pt-BR")
        : "";
      return [name, crmv, date].filter((part) => !!part).join(" • ") || "-";
    },
  },
  methods: {
    open() {
      this.$emit("open", this.vaccination);
    },
  },
};
</script>

<style scoped>
.timeline-card {
  transition: box-shadow 0.2s;
}
.timeline-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}
</style>
